import { render, staticRenderFns } from "./DetailDocHistory.vue?vue&type=template&id=e4382740&scoped=true"
import script from "./DetailDocHistory.vue?vue&type=script&lang=js"
export * from "./DetailDocHistory.vue?vue&type=script&lang=js"
import style0 from "./DetailDocHistory.vue?vue&type=style&index=0&id=e4382740&prod&scoped=true&lang=css"
import style1 from "./DetailDocHistory.vue?vue&type=style&index=1&id=e4382740&prod&lang=css"
import style2 from "./DetailDocHistory.vue?vue&type=style&index=2&id=e4382740&prod&scoped=true&lang=css"
import style3 from "./DetailDocHistory.vue?vue&type=style&index=3&id=e4382740&prod&scoped=true&lang=css"
import style4 from "./DetailDocHistory.vue?vue&type=style&index=4&id=e4382740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4382740",
  null
  
)

export default component.exports